import React from "react";
import ComponentCustomModal from "../../components/common/customModal/ComponentCustomModal";
import { useTranslation } from "react-i18next";

const PingDetails = ({ show, setShow, pingData }) => {
  const { t } = useTranslation();

  const isLoading = !pingData;

  return (
    <ComponentCustomModal
      show={show}
      setShow={setShow}
      centered
      size="md"
      header={t("pingDetails")}
    >
      <div className="p-2">
        {/*  Loading State */}
        {isLoading && (
          <div className="text-center py-4">
            <span className="spinner-border spinner-border-sm text-primary me-2"></span>
            {t("loading")}
          </div>
        )}

        {/*  Ping Data */}
        {!isLoading && (
          <div className="row">
            <PingRow label={t("seq")} value={pingData?.seq} />
            <PingRow label={t("host")} value={pingData?.host} />
            <PingRow label={t("size")} value={pingData?.size} />
            <PingRow label={t("ttl")} value={pingData?.ttl} />
            <PingRow label={t("time")} value={pingData?.time} />
            <PingRow label={t("sent")} value={pingData?.sent} />
            <PingRow label={t("received")} value={pingData?.received} />

            <PingRow
              label={t("packetLoss")}
              value={pingData?.["packet-loss"]}
            />

            <PingRow label={t("minRtt")} value={pingData?.["min-rtt"]} />

            <PingRow label={t("avgRtt")} value={pingData?.["avg-rtt"]} />

            <PingRow label={t("maxRtt")} value={pingData?.["max-rtt"]} />

            <PingRow label={t("mikrotik")} value={pingData?.mikrotik} />
          </div>
        )}
      </div>
    </ComponentCustomModal>
  );
};

/*  Reusable Row Component */
const PingRow = ({ label, value }) => {
  // if empty then will be hide
  if (value === undefined || value === null || value === "") {
    return null;
  }

  return (
    <div className="col-12 mb-2">
      <div className="d-flex justify-content-between ">
        <span>{label} :</span>
        <span>{value}</span>
      </div>
    </div>
  );
};

export default PingDetails;
